export default __webpack_public_path__ + "static/media/set13.52909a6d.jpeg";